module.exports = "pegasus_template/assets/tech/safari/103.png";